export const DoneIcon = () => {
  return (
    <>
      <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#fff"
          d="M12.733 20.2l11.3-11.3c0.267-0.267 0.578-0.4 0.933-0.4s0.667 0.133 0.933 0.4c0.267 0.267 0.4 0.584 0.4 0.951s-0.133 0.684-0.4 0.949l-12.233 12.267c-0.267 0.267-0.578 0.4-0.933 0.4s-0.667-0.133-0.933-0.4l-5.733-5.733c-0.267-0.267-0.395-0.583-0.384-0.949s0.15-0.683 0.417-0.951c0.268-0.268 0.584-0.401 0.951-0.4s0.683 0.134 0.949 0.4l4.733 4.767z"
        />
      </svg>
    </>
  );
};

export const NotConfirmEmailIcon = () => {
  return (
    <>
      <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#fff"
          d="M16 17.867l-6.533 6.533c-0.244 0.244-0.556 0.367-0.933 0.367s-0.689-0.122-0.933-0.367c-0.244-0.244-0.367-0.556-0.367-0.933s0.122-0.689 0.367-0.933l6.533-6.533-6.533-6.533c-0.244-0.244-0.367-0.556-0.367-0.933s0.122-0.689 0.367-0.933c0.244-0.244 0.556-0.367 0.933-0.367s0.689 0.122 0.933 0.367l6.533 6.533 6.533-6.533c0.244-0.244 0.556-0.367 0.933-0.367s0.689 0.122 0.933 0.367c0.244 0.244 0.367 0.556 0.367 0.933s-0.122 0.689-0.367 0.933l-6.533 6.533 6.533 6.533c0.244 0.244 0.367 0.556 0.367 0.933s-0.122 0.689-0.367 0.933c-0.244 0.244-0.556 0.367-0.933 0.367s-0.689-0.122-0.933-0.367l-6.533-6.533z"
        />
      </svg>
    </>
  );
};
